import { useEffect, useRef, useState } from "react";
// 1. حذف axios و ایمپورت api اختصاصی
import api from './api';

export const usePost = (url, payload, changeState = null) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState("");
    const [loaded, setLoaded] = useState(false);

    const effectRan = useRef(false);

    useEffect(() => {
        if (!url) return;

        // جلوگیری از اجرای دوباره در React.StrictMode
        if (effectRan.current === false) {
            (async () => {
                try {
                    setLoaded(false);
                    // 2. استفاده از api.post برای اعمال خودکار توکن
                    const response = await api.post(url, payload);
                    setData(response.data);
                } catch (err) {
                    console.error("usePost Error:", err);
                    // گرفتن متن ارور از ریسپانس سرور (اگر موجود باشد)
                    const errorMsg = err.response?.data?.message || err.message;
                    setError(errorMsg);
                } finally {
                    setLoaded(true);
                }
            })();

            effectRan.current = true;
        }
    }, [url, changeState]);

    return { data, loaded, error };
};
